<template>
  <div>
    <div class="top_carousel">
      <left-head v-if="common==='leftHead'" :activeIndex="activeIndex" class="left"></left-head>
      <right-head :activeIndex="activeIndex" :showNav="showNav"  :navColor="navColor" v-else></right-head>
      <div class="nav_padding"></div>
      <div  class="recommendPage">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(item,index) in carouselList " :key="index"><img :src="item.image" style="width: 100%;height: auto;-webkit-user-drag: none"/></swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>

  </div>
</template>

<script>
import leftHead from "./leftHead";
import rightHead from "./rightHead";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "pageHead",
  components: {leftHead, rightHead,swiper, swiperSlide},
  data(){
    return{
      isCollapse:true,
      carouselList:[
        {id:1,image:require('../../assets/image/index/bannerNew1.webp')},
        {id:2,image:require('../../assets/image/index/bannerNew2.webp')},
        {id:3,image:require('../../assets/image/index/bannerNew3.webp')},
        {id:4,image:require('../../assets/image/index/bannerNew4.webp')},
      ],
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        //鼠标控制
        // mousewheel: true,
        //垂直轮播
        // direction: 'vertical',
        // slidesPerView: 'auto',
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    }
  },
  props:{
      common:{
        type:String
      },
    activeIndex:{
      type:String
    },
    showNav:{
        type:Boolean
    },
    navColor:{
        type:Number
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    let that=this;
    // 点击除常用语框外的地方关闭常用语框
    document.addEventListener('mouseup',(e) =>{
      let tree = this.$refs.treeWrap;
      if (tree) {
        if (!tree.contains(e.target)) {
          that.isCollapse =true;
        }
      }
    })
  },

  methods:{
    menuZoom(flag){
      let that=this;
      that.isCollapse=flag;
    },
    getChild(v){
      this.$emit('positionVal', v)
    }
  },

}
</script>

<style scoped>

.top_carousel{
  width:100%;
  /*height: 30vw;*/
}
.recommendPage .swiper-container{
  position: relative;
  width: 100%;
  height: 30vw;
}
.recommendPage .swiper-container .swiper-slide{
  width: 100%;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
  background-image: url('~/assets/image/index/leftArrow.png');
  left: 10px;
  right: auto;
}
.swiper-button-prev, .swiper-button-next {
  width: 28px;
  height: 15px;
}
.swiper-button-next, .swiper-container-rtl .swiper-button-prev {
  background-image: url('~/assets/image/index/rightArrow.png');
  right: 10px;
  left: auto;
}@media (min-width: 1200px) {

}
@media  (min-width: 979px) and (max-width: 1200px)  {
  .top_carousel{
    width: 100%;
  }
}

/* 平板电脑和小屏电脑之间的分辨率 */
@media (min-width: 768px) and (max-width: 979px) {
  .top_carousel{
    width: 100%;
  }
}

/* 横向放置的手机和竖向放置的平板之间的分辨率 */
@media (max-width: 768px) {
  .top_carousel{
    width: 100%;
    height: 37vw;
  }
  .nav_padding{
    width: 100%;
    height: 48px;
  }
  .top_carousel{
    width: 100%;
  }
  .swiper-button-prev{
    display: none;
  }
  .swiper-button-next{
    display: none;
  }

}

/* 横向放置的手机及分辨率更小的设备 */
@media (max-width: 480px) {
  .top_carousel{
    width: 100%;
    height: 43vw;
  }
  .nav_padding{
    width: 100%;
    height: 3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/pageHead.vue